import React from 'react';
import './Commonshape.css';
import partbu from '../../../imgs/partbulbs.webp';

const Commonshape = () => {
    return (
        <div className="Commonsh-container">
            <div className='Ordinarys'>
                <h2 className="Commonsh-title">The Common and Popular Shapes of LED Bulbs</h2>
                <p className="Commons-date">Sep. 2, 2022</p>



                <div className="Commonsh-content">
                    <p className="Commonsh-text">There are a variety of shapes, styles and sizes of light bulbs on the market.</p>
                    <p className="Commonsh-text">Each light bulb shape has a name, consisting of letters and numbers,
                        with the letters representing the shape and the numbers representing the size.</p>
                    <p className="Commonsh-text">For example, a common household light bulb is an “A60” lamp.
                        Here “A” represents the shape of the bulb and “60”
                        is the diameter of the bulb at its widest point.</p>

                </div>
                <div className="Commonsh">
                    <img src={partbu} alt="72 Cavity PET Preforms Machine" className="Commonsh-image" />
                </div>

            </div>

        </div>
    );
};

export default Commonshape;
